<template>
	<div :class="{'has-error': mensagemErro}">
		<label>
			<span v-if="obrigatorio">*</span> {{ label }}:
			<i
				v-if="info != ''"
				class="fa fa-fw fa-info-circle has-tooltip"
				v-tooltip="info"
			></i
		></label>
		<div style="display: flex">
			<select
				v-if="!vueSelect"
				:disabled="disabled"
				:value="value"
				@input="$emit('input', $event.target.value)"
				@change="$emit('change', $event.target.value)"
				class="form-control input-sm"
			>
				<option value="" :disabled="disabledDefault">
					{{ this._traducao('global', opcaoDefault).toUpperCase() }}
				</option>
				<option
					v-for="(opcao, index) in listaOpcoes"
					:key="`select-${opcao[campoValor]}-${index}`"
					:value="opcao[campoValor]"
				>
					{{ opcao[labelOption] ? opcao[labelOption].toUpperCase() : '' }}
				</option>
			</select>
			<v-select
				v-else
				:label="labelOption"
				class="form-control input-sm"
				@input="(value) => $emit('input', value)"
				@change="(value) => $emit('change', value)"
				:disabled="disabled"
				:options="listaOpcoes"
				:value="value"
			>
				<template #option="props">
					<slot name="vue-select">
						<div>{{ props[labelOption] }}</div>
					</slot>
				</template>
			</v-select>
			<button
				v-if="showNovo"
				type="button"
				class="btn btn-sm btn-info pull-left"
				style="margin-left: 5px; height: 28px"
				@click.prevent.stop="$emit('abrir-novo')"
			>
				<i class="fa fa-plus fa-fw"></i>
				{{ _traducao('global', 'novo') }}
			</button>
		</div>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
export default {
	props: {
		info: {
			type: String,
			default: ''
		},

		label: {
			type: String,
			required: true
		},

		labelOption: {
			type: String,
			default: 'label'
		},

		campoValor: {
			type: String,
			default: 'value'
		},

		opcoes: {
			type: Array,
			required: false,
			default: function () {
				return []
			}
		},

		opcoesObjeto: {
			type: Array,
			required: false,
			default: function () {
				return []
			}
		},

		opcaoDefault: {
			required: false,
			default: 'escolha',
			type: String
		},

		value: {
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		disabled: {
			type: Boolean,
			default: false
		},

		disabledDefault: {
			type: Boolean,
			default: false
		},

		vueSelect: {
			type: Boolean,
			default: false
		},

		showNovo: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		listaOpcoes() {
			let retorno = []
			if (this.opcoesObjeto.length > 0) {
				retorno = this.opcoesObjeto
			} else {
				retorno = this.opcoes.map((opcao) => {
					return {
						label: opcao,
						value: opcao
					}
				})
			}

			this.$forceUpdate()

			return retorno
		}
	}
}
</script>